// Галочка успеха (штрих в стиле макета): линия выводится от начала до конца, как карандашом, концы
// прямые, как в макете. `pathLength="1"` даёт длину штриха в единицах, поэтому
// dash считается без измерения пути.
const DRAW_CSS = `
@keyframes stroke-draw { from { stroke-dashoffset: 1 } to { stroke-dashoffset: 0 } }
.stroke-draw { stroke-dasharray: 1; animation: stroke-draw 1.8s cubic-bezier(0.65, 0, 0.35, 1) both }
@media (prefers-reduced-motion: reduce) { .stroke-draw { animation: none; stroke-dashoffset: 0 } }
`

/** Декоративная: смысл несёт подпись рядом. */
export const PaymentStroke = () => (
  <svg width="156" height="114" viewBox="0 0 156 114" fill="none" aria-hidden="true">
    <style>{DRAW_CSS}</style>
    <defs>
      <linearGradient
        id="payment-stroke-gradient"
        x1="12"
        y1="60"
        x2="144"
        y2="50"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#894DFF" />
        <stop offset="1" stopColor="#B8DCFE" />
      </linearGradient>
    </defs>
    <path
      className="stroke-draw"
      pathLength="1"
      d="M14 66C30 72 44 84 56 95C62 100 72 100 80 90C100 64 122 38 144 20"
      stroke="url(#payment-stroke-gradient)"
      strokeWidth="20"
      strokeLinejoin="round"
    />
  </svg>
)
